import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import Login from '../components/Login';
import Register from '../components/Register';
import { motion } from 'framer-motion';
import '../css/Auth.css';
import '../css/Auth.scss';

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL


const backdropVariants = {
    expanded: {
        width: "245%",
        height: "1300px",
        borderRadius: "15%",
        transform: "rotate(60deg)",
    },
    collapsed: {
        width: "160%",
        height: "550px",
        borderRadius: "50%",
        transform: "rotate(60deg)",
    },
};

const expandingTransition = {
    type: "spring",
    duration: 2.3,
    stiffness: 30,
};
const Auth = ({ setCurrentUser }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [isExpanded, setExpanded] = useState(false);
    const [active, setActive] = useState(searchParams.get('active'));
    useEffect(()=>{
        if (searchParams.get('active')==='signin' && active!='signin'){
            switchToSignin()
        }
        else if (searchParams.get('active')==='signup' && active!='signup'){
            switchToSignup()
        }
        setSearchParams()
    }, [searchParams])
    let username, email, password, password2

    const getJobs = async (token) => {
        const res = await fetch(`${REACT_APP_BACKEND_URL}/jobs/`, {
            method: "GET",
            headers: { "Authorization": `Token ${token}` }
        });
        const data = await res.json();
        return data
    };
    const getUser = async (username, password) => {
        const res = await fetch(`${REACT_APP_BACKEND_URL}/api/login/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                "username": username,
                "password": password
            })
        })
        const data = await res.json();
        return data
    };


    const signUpUser = async (e) => {
        e.preventDefault();
        const username = e.target.username.value
        const email = e.target.email.value
        const password = e.target.password1.value
        const password2 = e.target.password2.value
        if (password !== password2) {
            alert("passwords don't match")
            return
        }
        const res = await fetch(`${REACT_APP_BACKEND_URL}/api/register/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                "username": username,
                "email": email,
                "password": password,
                "password2": password2
            })
        });
        const data = await res.json();
        console.log(data);
        switchToSignin()
    };

    const signInUser = async (e) => {
        e.preventDefault();
        const username = e.target.username.value
        const password = e.target.password1.value
        const data = await getUser(username, password)
        console.log(data, 'data')
        if (!data.token) {
            alert("Incorrect username or password.")
            return
        };
    
        const user = {
            token: data.token,
            username,
        };

        setCurrentUser(user);
        console.log(user)
        localStorage.setItem('tracker_user', JSON.stringify(user));
        navigate('/');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        active === 'signin' ? signInUser(e) : signUpUser(e)
    };
    const playExpandingAnimation = () => {
        setExpanded(true);
        setTimeout(() => {
            setExpanded(false);
        }, expandingTransition.duration * 1000 - 1500);
    };
    const switchToSignup = () => {
        playExpandingAnimation();
        setTimeout(() => {
            setActive("signup");
        }, 750);
    };
    const switchToSignin = () => {
        playExpandingAnimation();
        setTimeout(() => {
            setActive("signin");
        }, 650);
    };
    const onElemFocus = (e) => {
        e.target.parentElement.classList.add("focusWithText");
    };
    
    const onElemBlur = (e) => {
        if(e.target.value === "") {
            e.target.parentElement.classList.remove("focusWithText");
        }
    };
    useEffect(() => {
        // eslint-disable-next-line
        username = document.querySelector('#username');
        // eslint-disable-next-line
        email = document.querySelector('#email');
        // eslint-disable-next-line
        password = document.querySelector('#password');
        // eslint-disable-next-line
        password2 = document.querySelector('#password2');
        // eslint-disable-next-line
        username.addEventListener('focus', onElemFocus);
        username.addEventListener('blur', onElemBlur);
        if (email){
            email.addEventListener('focus', onElemFocus);
            email.addEventListener('blur', onElemBlur);
            password2.addEventListener('focus', onElemFocus);
            password2.addEventListener('blur', onElemBlur);
        }
        password.addEventListener('focus', onElemFocus);
        password.addEventListener('blur', onElemBlur);    
      return () => {
        username.removeEventListener('focus', onElemFocus);
        username.removeEventListener('blur', onElemBlur);
        if (email){
            email.removeEventListener('focus', onElemFocus);
            email.removeEventListener('blur', onElemBlur);
            password2.removeEventListener('focus', onElemFocus);
            password2.removeEventListener('blur', onElemBlur);
        }
        password.removeEventListener('focus', onElemFocus);
        password.removeEventListener('blur', onElemBlur);
      }
    }, [active])
    /* -- End Page Switcg Animation -- */
    return (
        <div className='grid place-items-center'>
            <div className='auth-container no-select'>
                <form id='form-auth' onSubmit={(e) => { handleSubmit(e) }}>
                <div className="svgContainer" >
                        <div style={{display: 'grid', placeItems: 'center', marginTop: '50px'}}>
                            {/* <Yeti /> */}
                            <p>Demo Credentials</p>
                            <p>Username: demo</p>
                            <p>Password: 1234</p>
                        </div>
                    </div>
                    <motion.div
                        id='backdrop'
                        initial={false}
                        animate={isExpanded ? "expanded" : "collapsed"}
                        variants={backdropVariants}
                        transition={expandingTransition}
                    />
                    {active === 'signin' ? <Login switchToSignup={switchToSignup} /> : <Register switchToSignin={switchToSignin} />}
                </form>

            </div>
        </div>
    )
};
export default Auth;